import { Reducer } from 'redux';
import { KnownAction } from './headerActions';
import { HeaderState } from './headerModels';

/* tslint:disable */
// ----------------
// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.
export const reducer: Reducer<HeaderState> = (state: HeaderState, action: KnownAction) => {
    if (state === null || state === undefined) {
        state = {
            bottomHeader: 'blib'
        };
    }

    switch (action.type) {
        case 'SET_BOTTOMHEADER':
            return Object.assign({}, state, { bottomHeader: action.data });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/data/header/headerReducers.ts